import { useCreateChat } from '@repo/api/chat/useCreateChat';
import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useNavigate } from 'react-router';

import { toasterMessageHandler } from '@/lib/toaster-message-handler';

/**
 * Opens the conversation between the signed-in parent and a teacher.
 *
 * `POST /api/chat` returns the existing one-to-one chat when there already is
 * one, so there is nothing to look up first — creating is idempotent here.
 *
 * The backend only allows this for teachers of the parent's children's groups
 * and answers 403 otherwise, which surfaces as a toast rather than a dead end.
 */
export function useMessageTeacher() {
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useCreateChat();

  const messageTeacher = async (teacherId: number) => {
    try {
      const chat = await mutateAsync({ userIds: [teacherId] });
      await navigate(`/chat/${chat.id}`);
    } catch (error) {
      toasterMessageHandler(baseErrorMessages, error instanceof Error ? error : null);
    }
  };

  return { messageTeacher, isPending };
}
